import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const WalletIntegration = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll('.fade-in-element')
    gsap.set(elements, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(elements, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.15,
          ease: 'power3.out'
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="wallet-integration-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2 className="fade-in-element wallet-heading">Wallet Integration</h2>
        <div className="wallet-grid">
          <div className="wallet-left fade-in-element">
            <div className="wallet-image" />
          </div>
          <div className="wallet-right fade-in-element">
            <ul>
              <li>
                The <strong>Real World Asset Wallet</strong> is interoperable with the <strong>StarMax Wallet</strong>.
              </li>
              <li>
                Backers can view their balances and manage funds in either the RWA or StarMax user interface.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WalletIntegration
